import type { ReactNode } from "react";
import type { InvestmentState } from "@/domain/investment/types";
import { InvestmentStateBar } from "./InvestmentStateBar";

export function InvestmentStateLabel({
  state,
  children,
}: {
  state: InvestmentState;
  children: ReactNode;
}) {
  return (
    <span className="flex items-center gap-2">
      <InvestmentStateBar state={state} />
      {children}
    </span>
  );
}
